import { render, staticRenderFns } from "./sidebars.vue?vue&type=template&id=46dd5570&scoped=true&lang=pug&"
import script from "./sidebars.vue?vue&type=script&lang=js&"
export * from "./sidebars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd5570",
  null
  
)

export default component.exports